import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DeployDialog from '../Devices/DeployDialog';

function DeployAll(props) {
  const [showDeployDialog, toggleDeployDialog] = useState(false);
  const { deployer, user: authUser } = props;
  const { downloadSchedule } = authUser;

  return (
    <>
      <button
        type="button"
        onClick={() => toggleDeployDialog(true)}
        className="w-full h-[50px] bg-[#00243E] rounded-lg text-white font-[700] poppins-bold
           hover:bg-sunrise/50  hover:shadow-md duration-200 active:bg-[#00243E] 
           hover:scale-105 flex items-center justify-center space-x-2 text-[24px]"
      >
        <span className="text-inherit">DEPLOY</span>
        <img src="/assets/images/icons/white_deploy_icon.svg" alt="deploy icon" />
      </button>
      <DeployDialog
        show={showDeployDialog}
        onHide={() => toggleDeployDialog(false)}
        deployer={deployer}
        downloadSchedule={downloadSchedule}
        auth={{ user: authUser }}
        deployAll
      />
    </>
  );
}

DeployAll.propTypes = {
  deployer: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

export default DeployAll;
